import { hbs } from 'ember-cli-htmlbars';
export default hbs("<BreadcrumbsContainer @itemClass=\'breadcrumbs__item\' class=\'breadcrumbs\' />")